/**
 * All new feature flags should use this convention.
 *
 * Are we crazy?
 * There were 2 main issues with exporting feature flags directly from this file.
 * 1. We got a lot of merge conflicts, because devs all tend to add new flags to the bottom.
 * 2. It's hard to mock feature flags independently in tests (you have to mock all flags that are evaluated during your tests).
 * Read the proposal - https://hello.atlassian.net/wiki/spaces/AG/pages/792046806/Discussion+-+Front+End+Avoiding+the+developer+experience+pitfalls+of+feature+flags
 */
import getCommitScenarioChangesBatchSize from './get-commit-scenario-changes-batch-size';
import getTtiExcludedUsers from './get-tti-excluded-users';
import isArjGicPrefilledDataHandlingEnabled from './is-arj-gic-prefilled-data-handling-enabled';
import isAssetCustomFieldForInternalEnabled from './is-asset-custom-field-for-internal-enabled';
import isMigrateArjTeamsToPlatformTeamsEnabled from './is-migrate-arj-teams-to-platform-teams-enabled';
import isPollinatorTenant from './is-pollinator-tenant';
/**
 * Keep these in alphabetical order to minimise merge conflicts
 * Hint: The imports are automatically ordered alphabetically by eslint, copy that order
 * If we were to export directly (export { default as isMyFlagEnabled } from './isMyFlagEnabled') we wouldn't get auto-ordering
 */
export {
	getCommitScenarioChangesBatchSize,
	getTtiExcludedUsers,
	isAssetCustomFieldForInternalEnabled,
	isArjGicPrefilledDataHandlingEnabled,
	isMigrateArjTeamsToPlatformTeamsEnabled,
	isPollinatorTenant,
};
